module.exports = __webpack_public_path__ + "img/zinaf.4842624f.png";